import { ShippingApi } from '../../../../Shippings/models/Shipping';
import { Skeleton } from '@mui/material';
import React from 'react';

interface ShippingStatusProps {
  shipping?: ShippingApi;
  isLoading: boolean;
  statusLabel?: string | null;
}

const ShippingStatus: React.FC<ShippingStatusProps> = ({ shipping, isLoading, statusLabel }) => {
  if (isLoading && !statusLabel) {
    return (
      <div className='flex items-center flex-shrink-0 ml-4'>
        <Skeleton width={140} height={48} sx={{ borderRadius: '14px' }} />
      </div>
    );
  }

  const label =
    statusLabel ||
    shipping?.status?.commercialName ||
    shipping?.status?.name ||
    'Procesado';

  return (
    <div className='flex items-center flex-shrink-0 ml-4'>
      <div className='px-4 py-2 rounded-xl bg-[#ff750008] border-2 border-[#ff750015] flex items-center gap-3'>
        <div className='w-2 h-2 rounded-full bg-[#ff7500] shadow-[0_0_8px_rgba(255,117,0,0.3)]' />
        <span className='text-[1.1rem] font-[800] uppercase tracking-wide text-[#ff7500] whitespace-nowrap'>
          {label}
        </span>
      </div>
    </div>
  );
};

export default ShippingStatus;
